/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three columns draw a three-circle Venn with all seven regions counted.`)
};

const es_venn_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tres columnas dibujan un Venn de tres círculos con las siete regiones contadas.`)
};

const de_venn_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drei Spalten zeichnen ein Drei-Kreis-Venn-Diagramm mit allen sieben gezählten Regionen.`)
};

const nl_venn_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drie kolommen tekenen een Venn-diagram met drie cirkels waarbij alle zeven regio's worden geteld.`)
};

const fr_venn_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trois colonnes tracent un Venn à trois cercles avec les sept régions comptées.`)
};

const it_venn_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tre colonne disegnano un Venn a tre cerchi con tutte e sette le regioni contate.`)
};

const pt_br2_venn_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três colunas desenham um Venn de três círculos com todas as sete regiões contadas.`)
};

const pt_venn_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três colunas desenham um Venn de três círculos com todas as sete regiões contadas.`)
};

const ja_venn_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3列の項目から、7つのすべての領域の件数を示す3円のベン図が描画されます。`)
};

const zh_venn_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三列项目绘制出一个三圆维恩图，计算全部七个区域的数量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_ex2", locale)
	if (locale === "en") return en_venn_ex2(inputs)
	if (locale === "es") return es_venn_ex2(inputs)
	if (locale === "de") return de_venn_ex2(inputs)
	if (locale === "nl") return nl_venn_ex2(inputs)
	if (locale === "fr") return fr_venn_ex2(inputs)
	if (locale === "it") return it_venn_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_venn_ex2(inputs)
	if (locale === "pt") return pt_venn_ex2(inputs)
	if (locale === "ja") return ja_venn_ex2(inputs)
	return zh_venn_ex2(inputs)
};